module.exports = __webpack_public_path__ + "img/observation.802147be.jpg";